import React from 'react';
import bgLight from '../../../public/auth/bg-light.png';
import mascot from '../../../public/auth/mascot.png';
import logoIcon from '../../../public/auth/logo-icon.png';
import logoText from '../../../public/auth/logo-text.png';
import mascotPeek from '../../../public/auth/mascot-peek.png';
import mascotPeekPaws from '../../../public/auth/mascot-peek-paws.png';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row font-sans">
      {/* ===== MOBILE HEADER (<lg) ===== */}
      <div className="lg:hidden relative h-[220px] flex-shrink-0 overflow-visible">
        {/* Background gradient */}
        <img
          src={bgLight}
          alt=""
          className="absolute inset-0 w-full h-full object-cover pointer-events-none dark:brightness-[0.3] dark:saturate-[2] dark:contrast-[1.2]"
        />

        {/* Logo */}
        <div className="relative z-10 flex items-center gap-1 pt-7 pl-6">
          <img src={logoIcon} alt="" className="w-[34px] h-[34px]" />
          <img src={logoText} alt="Tereiko" className="h-[28px] w-auto" />
        </div>

        {/* Peeking mascot */}
        <div className="absolute right-6 top-[65px] z-20 pointer-events-none">
          <img src={mascotPeek} alt="Tereiko mascot" className="w-[150px] h-auto" />
          <img
            src={mascotPeekPaws}
            alt=""
            className="absolute -bottom-[10px] left-1/2 -translate-x-1/2 w-[75px] h-auto"
          />
        </div>
      </div>

      {/* ===== DESKTOP LEFT PANEL (lg+) ===== */}
      <div className="hidden lg:block w-[480px] xl:w-[520px] flex-shrink-0 p-5 bg-white dark:bg-grey-950">
        <div className="h-full rounded-[30px] relative overflow-hidden flex flex-col items-center justify-center">
          <img
            src={bgLight}
            alt=""
            className="absolute inset-0 w-full h-full object-cover pointer-events-none rounded-[30px] dark:brightness-[0.3] dark:saturate-[2] dark:contrast-[1.2] transition-[filter] duration-300"
          />

          <div className="relative z-10 flex flex-col items-center text-center">
            <div className="relative w-[160px] h-[242px] mb-2 -ml-12">
              <img src={mascot} alt="Tereiko mascot" className="w-full h-full object-contain" />
            </div>

            <div className="w-[118px] h-[20px] -mt-6 mb-4">
              <svg
                width="118"
                height="20"
                viewBox="0 0 118 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full"
              >
                <ellipse cx="59" cy="10" rx="59" ry="10" className="fill-grey-900" fillOpacity="0.24" />
              </svg>
            </div>

            <h2 className="text-[32px] font-bold uppercase leading-[48px] tracking-[0px] text-grey-800 dark:text-white mb-1">
              Enjoy learning
            </h2>
            <p className="text-base leading-6 text-text-primary/[0.64] dark:text-white/60">
              More effectively with Tereiko
            </p>
          </div>
        </div>
      </div>

      {/* ===== CONTENT AREA (shared, rendered once) ===== */}
      <div
        className="flex-1 flex flex-col relative z-10
          rounded-t-[30px] -mt-[30px] lg:rounded-none lg:mt-0
          bg-white dark:bg-grey-950 lg:min-h-screen"
      >
        {/* consent-safe-bottom: reserves room while the fixed cookie banner is up,
            so the sign-up wizard's primary button is never occluded on mobile. */}
        <div className="consent-safe-bottom flex-1 flex items-start lg:items-center justify-center px-6 sm:px-8 pt-8 lg:py-12">
          <div className="w-full max-w-[400px]">{children}</div>
        </div>

        <div className="px-8 pb-6 text-right">
          <a
            href="#"
            className="text-sm text-grey-800 dark:text-grey-600 lg:text-grey-600 font-semibold lg:font-normal hover:text-primary-500 dark:hover:text-neutral-300 transition-colors"
          >
            Need help?
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
